const messages = {
    en: {
        delivery: {
            stockOperation: {
                SHOW: 'Show ',
                ADD: 'Add',
                MOVE: 'Move',
                REMOVE: 'Remove',
                REGULARIZE: 'Regularize',
                SOLD: 'Sold',
                RESTORE: 'Restore',
                destinationBranch: 'Destination branch'
            }
        }
    },
    es: {
        delivery: {
            stockOperation: {
                SHOW: 'Mostrar',
                ADD: 'Reposición',
                MOVE: 'Movimiento',
                REMOVE: 'Baja',
                REGULARIZE: 'Regularizar',
                SOLD: 'Venta',
                RESTORE: 'Restaurado',
                destinationBranch: 'Sucursal destino'
            }
        }
    },
    pt: {
        delivery: {
            stockOperation: {
                SHOW: 'Mostrar Stock',
                ADD: 'Agregar stock',
                MOVE: 'Mover stock',
                REMOVE: 'Dar de baja stock',
                REGULARIZE: 'Regularizar',
                RESTORE: 'Restaurado',
                destinationBranch: 'Sucursal destino'
            }
        }
    }
}

export default messages
